import React from "react";
import { hydrate } from "react-dom";
import createStore from '../shared/Reducers/createStore'
import { Provider } from "react-redux";
import { BrowserRouter as Router } from 'react-router-dom'
import routes from '../shared/routes'
import { renderRoutes } from 'react-router-config'

const initialState = window.___INITIAL_STATE__ || {}
const store = createStore(initialState)

hydrate(
  <Provider store={store}>
    <Router onEnter={() => window.scrollTo(0, 0)}>
      {renderRoutes(routes)}
    </Router>
  </Provider>,
  document.getElementById("root")
);